import React from 'react';
import PlaceholderPage from './PlaceholderPage';

const ReceivablesPage: React.FC = () => (
  <PlaceholderPage
    title="客户应收"
    summary="客户价卡、应收核对/改价、水单登记与核销入口将挂在本页（不新增客户管理菜单）。"
    designSection="应收管理 / kac-004、kac-005"
  />
);

export default ReceivablesPage;
